<button [disabled]="disabled" [ngClass]="getClasses()" (click)="clickButton($event)" class="no-select" id="button">
  <div class="button-content" [ngClass]="{ hidden: loading }">
    <ng-content select="[content]"></ng-content>
  </div>
  <div class="button-text" [ngClass]="{ hidden: loading }">
    <ng-content select="[description]"></ng-content>
  </div>
  <div class="button-content" [ngClass]="{ hidden: loading }">
    <ng-content select="[second-content]"></ng-content>
  </div>
  <div *ngIf="loading" class="loading">
    <div class="loadingio-spinner-dual-ring-5lztzerqvhy">
      <div class="ldio-23sgvj19m2h">
        <div></div>
        <div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</button>
